import React from 'react';
import Grid from '@mui/material/Grid2';
import {
  FilterControl,
  FilterSelect,
  FilterTextInput,
} from '../../common/table/filter-controls';
import TableResultsSummary from '../../common/table/table-results-summary';

const STATUS_OPTIONS = [
  { value: 'nominated', labelKey: 'common-nominated' },
  { value: 'active', labelKey: 'common-active' },
  { value: 'exited', labelKey: 'common-exited' },
];

const INVITATION_OPTIONS = [
  { value: 'common-edm-bounced', labelKey: 'common-edm-bounced' },
  { value: 'common-edm-send', labelKey: 'common-edm-send' },
  { value: 'common-edm-open', labelKey: 'common-edm-open' },
  { value: 'common-edm-click', labelKey: 'common-edm-click' },
];

const FILTER_GRID = {
  name: { xs: 12, sm: 6, md: 3 },
  standard: { xs: 12, sm: 6, md: 2 },
  retailer: { xs: 12, sm: 6, md: 5 },
  action: { xs: 12, sm: 6, md: 2 },
  reset: { xs: 12, sm: 6, md: 3 },
};

function TableHacFilters({
  t,
  showMarketFilter,
  showCountryFilter,
  markets,
  loggedUser,
  countries,
  retailers,
  showPmaFilter = false,
  pmas = [],
  filters,
  showStatusFilter = true,
  showInvitationFilter = false,
  onFilterChange,
  onApply,
  onReset,
  filteredHacs,
  showSummary = true,
}) {
  const availableMarkets = markets
    .filter((market) => loggedUser?.market?.includes(market.name))
    .map((market) => ({
      value: market.name,
      label: t(`${market.name}`),
    }));
  const retailerOptions = retailers.map((retailer) => ({
    value: retailer,
    label: retailer,
  }));
  const pmaOptions = pmas.map((pma) => ({
    value: pma.email,
    label: `${pma.name} ${pma.last_name}`,
  }));
  const statusOptions = STATUS_OPTIONS.map((option) => ({
    value: option.value,
    label: t(option.labelKey),
  }));
  const invitationOptions = INVITATION_OPTIONS.map((option) => ({
    value: option.value,
    label: t(option.labelKey),
  }));

  return (
    <div className="filters">
      <p>{t('common-search')}</p>
      <Grid container spacing={3} rowSpacing={0}>
        <Grid size={FILTER_GRID.name}>
          <FilterControl id="name" label={`${t('common-name')}/${t('common-last-name')}`}>
            <FilterTextInput
              id="name"
              value={filters.name}
              onChange={onFilterChange}
            />
          </FilterControl>
        </Grid>

        {showMarketFilter && (
          <Grid size={FILTER_GRID.standard}>
            <FilterControl id="market" label={t('common-market')}>
              <FilterSelect
                id="market"
                value={filters.market}
                onChange={onFilterChange}
                options={availableMarkets}
                allLabel={t('common-all-market')}
              />
            </FilterControl>
          </Grid>
        )}

        {showCountryFilter && (
          <Grid size={FILTER_GRID.standard}>
            <FilterControl id="country" label={t('common-country')}>
              <FilterSelect
                id="country"
                value={filters.country}
                onChange={onFilterChange}
                options={countries}
                allLabel={t('common-all-country')}
              />
            </FilterControl>
          </Grid>
        )}

        {showStatusFilter && (
          <Grid size={FILTER_GRID.standard}>
            <FilterControl id="status" label={t('common-status')}>
              <FilterSelect
                id="status"
                value={filters.status}
                onChange={onFilterChange}
                options={statusOptions}
                allLabel={t('common-all-status')}
              />
            </FilterControl>
          </Grid>
        )}

        <Grid size={FILTER_GRID.retailer}>
          <FilterControl id="retailer" label={t('common-retailer')}>
            <FilterSelect
              id="retailer"
              value={filters.retailer}
              onChange={onFilterChange}
              options={retailerOptions}
              allLabel={t('common-all-retailers')}
            />
          </FilterControl>
        </Grid>

        {showInvitationFilter && (
          <Grid size={FILTER_GRID.standard}>
            <FilterControl id="invitation" label={t('common-invitation')}>
              <FilterSelect
                id="invitation"
                value={filters.invitation}
                onChange={onFilterChange}
                options={invitationOptions}
                allLabel={t('common-all-invitations')}
              />
            </FilterControl>
          </Grid>
        )}

        {showPmaFilter && (
          <Grid size={FILTER_GRID.standard}>
            <FilterControl id="pma" label={t('common-role-pma')}>
              <FilterSelect
                id="pma"
                value={filters.pma}
                onChange={onFilterChange}
                options={pmaOptions}
                allLabel={t('common-all-pma')}
              />
            </FilterControl>
          </Grid>
        )}
      </Grid>

      {showSummary && (
        <TableResultsSummary count={filteredHacs.length} />
      )}

      <Grid container spacing={3}>
        <Grid size={FILTER_GRID.action}>
          <div className="actions">
            <button className="btn" onClick={onApply}>
              {t('common-apply')}
            </button>
          </div>
        </Grid>

        <Grid size={FILTER_GRID.reset}>
          <div className="actions">
            <button onClick={onReset} className="btn text narrow">
              {t('common-reset-filters')}
            </button>
          </div>
        </Grid>
      </Grid>

    </div>
  );
}

export default TableHacFilters;
